import { Card, Drawer } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { AbstractlistActivityFxn } from './actions'

const AbstractActivityList = (props) => {
  let { visible, onClose, abstractId, abstractIdNo } = props
  let [activityList, setActivityList] = useState([])

  useEffect(() => {
    if (visible && abstractId) {
      apiRequest()
    }
  }, [visible, abstractId])

  // const apiRequest = async () => {
  //   // Calling the action directly as per your established working pattern
  //   let resp = await AbstractlistActivityFxn({ abstractId })
  //   console.log(resp,"api response")
  //
  //   // Standardizing data extraction based on your backend response structure
  //   if (resp && resp.data) {
  //     setActivityList(resp.data)
  //   } else {
  //     setActivityList([])
  //   }
  // }
  const apiRequest = async () => {
    let resp = await AbstractlistActivityFxn({ abstractId });
    console.log("DEBUG: Full API Response:", resp);

    // The response object directly contains the 'data' array
    if (resp && Array.isArray(resp.data)) {
      setActivityList(resp.data);
    } else {
      console.warn("DEBUG: No activity data found in response");
      setActivityList([]);
    }
  }
  return (
    <Drawer
      title={`Abstract Activities Details | ${abstractIdNo || ''}`}
      width={'65%'}
      visible={visible}
      placement='right'
      onClose={onClose}>
      <Card className={'activityCard'} bordered={false}>
        {activityList && activityList.length > 0 ? (
          activityList.map((item, i) => (
            <div key={i} className='custom_card mb10'>
              <Card
                bordered={true}
                title={
                  <div>
                    {/* Matches your schema: user.name */}
                    {item.user && item.user.name ? item.user.name : 'Admin'}
                    <span style={{ marginLeft: 8 }}>({item.status || 'Note'})</span>
                  </div>
                }
                extra={
                  // Matches your schema: addedOn
                  <>{item.addedOn ? moment(item.addedOn).format('DD.MM.YYYY, h:mm A') : ''}</>
                }>
                {/* Matches your schema: details */}
                {item.details}
              </Card>
            </div>
          ))
        ) : (
          <p>No activity logs found.</p>
        )}      </Card>
    </Drawer>
  )
}

export default AbstractActivityList
